import { render, staticRenderFns } from "./CodeKinds.vue?vue&type=template&id=39b51d87&"
import script from "./CodeKinds.vue?vue&type=script&lang=js&"
export * from "./CodeKinds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports